module.exports = __webpack_public_path__ + "img/headpic.769493ad.png";